import SiteConfig from '../services/positiva';
import store from '@/store'

export function getAccessToken() {
  return store.state.auth.token;
}
